import React from "react"
import Link from "../utils/link"

function OpenSeaLogo(props) {
    return (
      <svg
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M19.42 9.698c0 5.246-4.304 9.5-9.612 9.5-5.307 0-9.61-4.254-9.61-9.5 0-5.247 4.303-9.5 9.61-9.5 5.31 0 9.611 4.253 9.611 9.5z"
          fill="#2081E2"
        />
        <path
          d="M16.084 10.735v.612a.088.088 0 01-.054.08c-.193.082-.856.383-1.131.761-.703.968-1.24 2.35-2.441 2.35h-5.01c-1.775 0-3.214-1.426-3.214-3.187v-.057c0-.046.039-.085.086-.085h2.793c.055 0 .096.051.09.105a.984.984 0 00.98 1.07h1.384v-1.066H8.2a.087.087 0 01-.071-.137l.05-.072c.129-.182.313-.464.497-.785a6.11 6.11 0 00.344-.68c.02-.042.036-.085.052-.127.026-.074.054-.143.074-.213.02-.058.035-.12.051-.177.047-.198.066-.406.066-.623 0-.085-.004-.174-.011-.259a3.315 3.315 0 00-.028-.278 2.853 2.853 0 00-.039-.248 4.133 4.133 0 00-.079-.37l-.01-.048c-.024-.084-.044-.165-.072-.25a9.386 9.386 0 00-.262-.77c-.035-.096-.074-.189-.114-.282-.058-.14-.117-.266-.172-.386a5.366 5.366 0 01-.075-.155 5.43 5.43 0 00-.082-.17c-.02-.042-.042-.081-.058-.12l-.169-.309c-.023-.042.016-.091.063-.079l1.056.283h.003l.004.001.14.038.152.043.057.016v-.62a.543.543 0 011.086 0v.92l.112.032a.09.09 0 01.026.013l.117.087c.04.032.082.07.134.109a8.025 8.025 0 01.458.398c.172.158.364.344.548.548.051.058.102.117.153.178.051.063.106.124.153.186.062.082.13.166.188.255.027.042.059.085.086.127.075.112.14.229.204.345.027.053.054.112.078.17a2.468 2.468 0 01.184.575v.008a.884.884 0 01.02.148 1.56 1.56 0 01-.087.69 2.706 2.706 0 01-.29.6 2.268 2.268 0 01-.09.143c-.034.05-.07.097-.101.143-.044.059-.09.12-.138.175a6.53 6.53 0 01-.329.387 2.05 2.05 0 01-.125.134c-.042.047-.086.089-.125.128a5.07 5.07 0 01-.168.158l-.109.098a.09.09 0 01-.058.022h-.841v1.067h1.058a.997.997 0 00.644-.236c.062-.053.334-.286.655-.636a.082.082 0 01.04-.024l2.924-.836a.086.086 0 01.11.082z"
          fill="#fff"
        />
      </svg>
    )
  }

  const OpenSea = () => {
    return(
        <li className="py-[10px] rounded-button bg-[#DBFF00] w-fit h-fit text-black text-[16px] font-bold tk-fatfrank rounded-[42px] px-[14px] transition-all duration-theme hover:scale-105">

        <Link to='https://opensea.io/collection/slowmoslothclub-smsc' className='flex items-center justify-center space-x-[8px]'><OpenSeaLogo className='h-[20px] w-[20px]'/> <span>OpenSea</span></Link>
        </li>
    )
  }

  export default OpenSea